module.exports = __webpack_public_path__ + "img/center-bg-3.d5d47bc7.png";